import { __awaiter } from "tslib";
/**
 * Given an object full of promises, resolves all of them and returns an object containing resultant values.
 * Roughly equivalent of Promise.all, but applies to an object.
 *
 * @param { Object } object - containing promises to resolve
 * @returns { Object } - Promise which resolves to an object containing resultant values
 */
export function promiseAllObject(object) {
    return __awaiter(this, void 0, void 0, function* () {
        const keys = Object.keys(object);
        const values = yield Promise.all(keys.map(key => object[key]));
        return keys.reduce((acc, key, index) => {
            acc[key] = values[index];
            return acc;
        }, {});
    });
}
/**
 * Implementation of map, but for Javascript Plain Objects.
 */
export function mapObject(obj, fn) {
    const result = {};
    for (const key of Object.keys(obj)) {
        result[key] = fn(obj[key], key);
    }
    return result;
}
/**
 * Delete all properties from an object.
 *
 * @param obj The object to clear.
 */
export function clearObject(obj) {
    for (const key of Object.keys(obj)) {
        delete obj[key];
    }
}
